import React from "react";

const Delete = (props: any) => {
    const deleteOption = () => {
        props.function();
    }
    return (
        <>
            <div className="modal fade" id="delete-modal">
                {/* modal structure */}
                <div className="modal-dialog modal-dialog-centered">
                    {/* modal content */}
                    <div className="modal-content">
                        {/* modal body */}
                        <div className="modal-body">
                            {/* modal card */}
                            <div className="card card-body modal-card border-0">
                                {/* modal content text */}
                                <div className="content">
                                    <p className="h5 card-title text-muted">
                                        {props.title}
                                    </p>
                                    <p className="mt-3">
                                        آیا مطمئنید {props.title} را میخواهید {props.control ? props.control : 'حذف'} کنید؟
                                    </p>
                                </div>
                                {/* modal buttons */}
                                <div className="buttons mt-1">
                                    <button className="btn btn-success px-4 me-2 py-2" data-bs-dismiss="modal" onClick={() => deleteOption()}>
                                        بله
                                    </button>
                                    <button id="close-modal" className="btn btn-outline-secondary  mt-md-0 mt-3 px-4 py-2"
                                        data-bs-dismiss="modal">
                                        خیر
                                    </button>
                                </div>
                            </div>
                            {/* end modal card   */}
                        </div>
                        {/* end modal body   */}
                    </div>
                    {/* end modal content */}
                </div>
                {/* end modal structure */}
            </div>
        </>
    )

}

export default Delete;